import { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import api from '@/services/api';

function Hearts({ value }) {
  const full = Math.round(value || 0);
  return (
    <div className="flex gap-0.5" aria-label={`${full} out of 5 hearts`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Heart key={i} className={`h-4 w-4 ${i <= full ? 'fill-primary text-primary' : 'text-muted-foreground/30'}`} />
      ))}
    </div>
  );
}

// Public client reviews for a stylist. Renders nothing when there are no reviews yet,
// so new stylists' profiles stay clean.
export function StylistReviews({ stylistId }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!stylistId) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/ratings/stylist/${stylistId}`);
        const list = Array.isArray(data) ? data : (data?.ratings || []);
        if (alive) setReviews(list);
      } catch (e) {
        /* no reviews / not available — stay hidden */
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [stylistId]);

  if (loading || reviews.length === 0) return null;

  return (
    <div className="space-y-4" data-testid="stylist-reviews">
      <h3 className="font-cormorant text-2xl font-bold">Client Reviews</h3>
      <div className="space-y-3">
        {reviews.slice(0, 6).map((r, i) => (
          <div key={r.rating_id || i} className="rounded-lg border border-border/40 p-4 bg-card/40">
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-sm text-foreground">{r.client_name || r.user_name || 'Verified client'}</span>
              <Hearts value={r.rating ?? r.hearts} />
            </div>
            {(r.feedback || r.comment) && (
              <p className="text-sm text-muted-foreground italic">"{r.feedback || r.comment}"</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default StylistReviews;
